exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#question-page {\n  display: block;\n  overflow: scroll;\n  width: 100%;\n  height: 100%;\n  background: url(/assets/bg.jpg);\n  background-size: cover;\n  background-position: top center; }\n  #question-page .question-container {\n    margin: 20px auto;\n    padding: 30px;\n    max-width: 800px;\n    background: rgba(255, 255, 255, 0.6); }\n    #question-page .question-container .quiz-option {\n      cursor: pointer;\n      font-size: 120%;\n      padding: 5px 0px;\n      margin: 20px 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/question/question.component.scss
// module id = 141
// module chunks = 1